import React from "react";
import LayoutStoreHome from "../../layouts/LayoutStoreHome";

const Template = () => {
  return (
    <LayoutStoreHome>
      <div className="section w-100 d-flex justify-content-center">
        <div>
          <h1 className="text-extra-large">Template page</h1>
        </div>
      </div>
    </LayoutStoreHome>
  );
};

export default Template;
